<template>
	<div class="fit">
		<q-card class="fit q-pa-md content-test no-rounded" :square="isMobile">
			<!-- Icones animados maiores -->
			<q-card-section class="justify-center" horizontal>
				<div class="row text-grey-6">
					<div class="col-12 text-center" v-if="!started">
						<img :src="`placeholders/clipboard.gif`" class="test-placeholder" />
					</div>

					<div class="col-12 text-center" v-if="finished && [1, 5, 50].includes(result.status)">
						<img :src="`placeholders/certificate.gif`" class="test-placeholder" />
					</div>

					<div class="col-12 text-center" v-if="finished && ![1, 5, 50].includes(result.status)">
						<img :src="`placeholders/stats.gif`" class="test-placeholder" />
					</div>

					<div class="col-12 text-uppercase text-body2" v-if="started && !finished">
						<div class="row">
							<div class="col-6">
								{{ $t('progress') }}
							</div>

							<div class="col-6 text-right">
								<vue-countdown
									v-if="countdown"
									:time="time_to_answer"
									v-slot="{ days, hours, minutes, seconds }"
									:emit-events="true"
									@end="countdownEnded()"
									@progress="handleProgress"
									:transform="transformValues"
								>
									<span :class="warning_class">
										{{ $t('question') }} {{ current_question + 1 }} {{ $t('of') }}
										{{ questions.length }}

										<p :class="warning_class">
											{{ $t('time_left') }}: {{ hours }}:{{ minutes }}:{{ seconds }}
										</p>
									</span>
								</vue-countdown>
							</div>
						</div>
						<q-linear-progress rounded size="10px" color="primary" :value="progress" />
					</div>
				</div>
			</q-card-section>
			<!-- cards menores com icones de tempo, status, etc -->
			<q-card-section
				v-if="!started && !finished"
				class="relative-position text-grey-6"
				:horizontal="isMobile"
			>
				<div class="row q-col-gutter-sm">
					<div class="col-xs-12 col-sm-4">
						<q-card flat class="bg-grey-2">
							<q-card-section>
								<q-list dense>
									<q-item class="padding-item">
										<q-item-section avatar>
											<q-icon name="far fa-clock" color="amber-14" size="md" />
										</q-item-section>

										<q-item-section>
											<q-item-label lines="1" class="text-uppercase text-caption">
												{{ $t('time_to_finish') }}
											</q-item-label>

											<q-item-label lines="1" class="text-weight-bold text-black">
												{{ timeToAnswer(activity.time_to_answer) }}
											</q-item-label>
										</q-item-section>
									</q-item>
								</q-list>
							</q-card-section>
						</q-card>
					</div>

					<div class="col-xs-12 col-sm-4">
						<q-card flat class="bg-grey-2">
							<q-card-section>
								<q-list dense>
									<q-item class="padding-item">
										<q-item-section avatar>
											<q-icon name="far fa-cut" color="purple" size="md" />
										</q-item-section>

										<q-item-section>
											<q-item-label lines="1" class="text-uppercase text-caption">
												{{ $t('minimum_to_pass') }}
											</q-item-label>

											<q-item-label lines="1" class="text-weight-bold text-black">
												{{
													$t('of_questions', {
														minimum_score: activity.minimum_score,
														qty_questions: activity.qty_questions,
													})
												}}
											</q-item-label>
										</q-item-section>
									</q-item>
								</q-list>
							</q-card-section>
						</q-card>
					</div>

					<div class="col-xs-12 col-sm-4">
						<q-card flat class="bg-grey-2">
							<q-card-section>
								<q-list dense>
									<q-item class="padding-item">
										<q-item-section avatar>
											<q-icon name="far fa-clipboard" :color="colorResult" size="xl" />
										</q-item-section>

										<q-item-section>
											<q-item-label lines="1" class="text-uppercase text-caption">
												{{ $t('your_status') }}
											</q-item-label>

											<q-item-label lines="1" class="text-grey-6">
												<span class="text-weight-bold text-black">{{ $t(textResult) }}</span>
												<span
													class="cursor-pointer"
													@click="show_previous_results = true"
													v-if="activity.user_test_results.length > 0"
												>
													({{ $t('view_history') }})
												</span>
											</q-item-label>
										</q-item-section>
									</q-item>
								</q-list>
							</q-card-section>
						</q-card>
					</div>
				</div>
			</q-card-section>

			<q-card-section v-if="!started && !finished" class="relative-position text-grey-6">
				<div class="row q-col-gutter-md text-center justify-center">
					<div class="col-xs-12 col-xl-6">
						<span class="text-weight-bold">{{ $t('attention') }}:</span>

						<span v-if="type === 'block_general_test'">
							{{
								$t(
									'you_have_only_one_attempt_to_pass_and_will_be_blocked_from_this_training_if_you_fail'
								)
							}}
						</span>

						<span v-if="type === 'restart_general_test'">
							{{
								$t(
									'you_have_only_one_attempt_to_pass_and_will_have_your_progress_restarted_in_this_training_if_you_fail'
								)
							}}
						</span>

						{{
							$t('once_you_start_the_test_you_should_not_change_activity_leave_or_refresh_the_page')
						}}
					</div>

					<div class="col-12 q-mt-md">
						<q-btn
							rounded
							:label="$t('start_test')"
							icon-right="fal fa-chevron-right"
							color="primary"
							@click="loadTest()"
							:disable="disableStartTest"
						/>
					</div>
				</div>
			</q-card-section>

			<q-card-section v-if="started && !finished">
				<q-scroll-area style="height: 60vh" class="q-py-md">
					<div class="col-12 q-mb-xl text-black">
						<div class="row q-col-gutter-md">
							<div class="col-12 text-weight-bold q-pl-lg linkfix">
								<span v-html="questions[current_question].title"></span>
							</div>

							<div
								class="col-12"
								v-for="answer in questions[current_question].answers"
								:key="answer.user_answer_id"
							>
								<q-card
									flat
									class="bg-grey-3 cursor-pointer"
									@click="questions[current_question].answer = answer.value"
								>
									<q-card-section>
										<q-item tag="label" v-ripple>
											<q-item-section avatar>
												<q-radio v-model="questions[current_question].answer" :val="answer.value" />
											</q-item-section>
											<q-item-section>
												<q-item-label v-html="answer.label"></q-item-label>
											</q-item-section>
										</q-item>
									</q-card-section>
								</q-card>
							</div>
						</div>
					</div>

					<div class="col-12 q-mb-lg text-right">
						<q-btn
							:disable="disableNextQuestion"
							rounded
							:label="$t(current_question + 1 < questions.length ? 'next_question' : 'finish_test')"
							:icon-right="
								$t(
									current_question + 1 < questions.length ? 'fal fa-chevron-right' : 'fal fa-check'
								)
							"
							color="primary"
							@click="saveAnswer()"
						/>
					</div>
				</q-scroll-area>
			</q-card-section>

			<q-card-section v-if="finished">
				<div class="row q-col-gutter-sm justify-center text-grey-6">
					<div class="col-xs-12 col-sm-5">
						<q-card flat class="bg-grey-2">
							<q-card-section>
								<q-list dense>
									<q-item class="padding-item">
										<q-item-section avatar>
											<q-icon name="far fa-clipboard-check" color="amber-14" size="lg" />
										</q-item-section>

										<q-item-section>
											<q-item-label lines="1" class="text-uppercase text-caption">
												{{ $t('test_performance') }}
											</q-item-label>

											<q-item-label lines="1" class="text-weight-bold text-black">
												{{
													$t('of_questions', {
														minimum_score: result.score,
														qty_questions: questions.length,
													})
												}}
											</q-item-label>
										</q-item-section>
									</q-item>
								</q-list>
							</q-card-section>
						</q-card>
					</div>

					<div class="col-xs-12 col-sm-5">
						<q-card flat class="bg-grey-2">
							<q-card-section>
								<q-list dense>
									<q-item class="padding-item">
										<q-item-section avatar>
											<q-icon
												name="far fa-clipboard"
												:color="[1, 5, 50].includes(result.status) ? 'positive' : 'negative'"
												size="lg"
											/>
										</q-item-section>

										<q-item-section>
											<q-item-label lines="1" class="text-uppercase text-caption">
												{{ $t('your_result') }}
											</q-item-label>

											<q-item-label
												lines="1"
												class="text-weight-bold text-black"
												v-if="[1, 5, 50].includes(result.status)"
											>
												{{ $t('approved') }}
											</q-item-label>

											<q-item-label lines="1" class="text-weight-bold text-black" v-else>
												{{ $t('reproved') }}
											</q-item-label>
										</q-item-section>
									</q-item>
								</q-list>
							</q-card-section>
						</q-card>
					</div>

					<div class="col-12 text-center q-mt-md">
						<q-btn
							rounded
							color="primary"
							icon="fal fa-chevron-left"
							:label="user_restarted_blocked ? $t('back_to_training') : $t('see_results')"
							@click="backToResults()"
						/>
					</div>
				</div>
			</q-card-section>
		</q-card>

		<!-- MOBILE -->
		<q-dialog v-if="isMobile" v-model="show_previous_results">
			<q-card style="min-width: 80vw; max-height: 80vh; height: 80vh">
				<q-toolbar>
					<q-toolbar-title>{{ $t('previous_results') }}</q-toolbar-title>

					<q-btn flat round dense icon="fal fa-times" v-close-popup />
				</q-toolbar>

				<q-separator />

				<q-card-section class="">
					<q-table
						:rows="activity.user_test_results"
						:columns="columns"
						row-key="name"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						grid
						hide-header
					>
						<template v-slot:item="props">
							<div
								class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
								:style="props.selected ? 'transform: scale(0.95);' : ''"
							>
								<q-card :class="props.selected ? 'bg-grey-2' : ''">
									<q-list dense>
										<q-item
											v-for="col in props.cols.filter((col) => col.name !== 'desc')"
											:key="col.name"
										>
											<q-item-section>
												<span v-if="col.label == 'see_answers'">
													<q-item-label class="text-center text-bold">{{
														$t(col.label)
													}}</q-item-label>
												</span>
												<span v-else
													><q-item-label>{{ $t(col.label) }}</q-item-label></span
												>
											</q-item-section>
											<q-item-section side>
												<q-item-label caption>
													<span v-if="col.label == 'date'">
														{{ $dateUtil.fDateTime(col.value) }}</span
													>
													<span v-else-if="col.label == 'status'" :class="statusColor(col.value)">
														{{ $t(statusText(col.value)) }}</span
													>
													<span v-else>{{ col.value }}</span>
												</q-item-label>
											</q-item-section>
										</q-item>
									</q-list>
								</q-card>
							</div>
						</template>
					</q-table>
				</q-card-section>
			</q-card>
		</q-dialog>

		<!-- DESKTOP -->
		<q-dialog v-else v-model="show_previous_results">
			<q-card style="min-width: 80vw; max-height: 80vh; height: 80vh">
				<q-toolbar>
					<q-toolbar-title>{{ $t('previous_results') }}</q-toolbar-title>

					<q-btn flat round dense icon="fal fa-times" v-close-popup />
				</q-toolbar>

				<q-separator />

				<q-card-section class="q-py-xl">
					<q-table
						:rows="activity.user_test_results"
						:columns="columns"
						row-key="name"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
					>
						<template v-slot:header="props">
							<q-tr :props="props">
								<q-th v-for="col in props.cols" :key="col.name" :props="props">
									{{ $t(col.label) }}
								</q-th>
							</q-tr>
						</template>

						<template v-slot:body="props">
							<q-tr :props="props">
								<q-td key="date" :props="props">
									{{ $dateUtil.fDateTime(props.row.date) }}
								</q-td>

								<q-td key="percent" :props="props"> {{ props.row.percent.toFixed(2) }}% </q-td>

								<q-td key="score" :props="props">
									{{ props.row.score }}
								</q-td>

								<q-td key="test_score" :props="props">
									{{ props.row.test_score }}
								</q-td>

								<q-td key="status" :props="props" :class="statusColor(props.row.status)">
									{{ $t(statusText(props.row.status)) }}
								</q-td>

								<q-td key="action" :props="props" :class="statusColor(props.row.status)">
									{{ $t(statusText(props.row.status)) }}
								</q-td>

								<q-td key="actions" :props="props">
									<q-icon
										name="fal fa-eye"
										size="1rem"
										@click="testSeeResult ? showPreviousResult(props.row) : ''"
										:class="testSeeResult ? 'cursor-pointer' : ''"
									/>
								</q-td>
							</q-tr>
						</template>
					</q-table>
				</q-card-section>
			</q-card>
		</q-dialog>

		<q-dialog v-model="show_previous_result">
			<q-card style="min-width: 80vw; max-height: 80vh">
				<q-toolbar>
					<q-toolbar-title>{{ $t('previous_results') }}</q-toolbar-title>

					<q-btn flat round dense icon="fal fa-times" v-close-popup />
				</q-toolbar>

				<q-separator />

				<q-card-section class="q-py-xl">
					<div class="row q-col-gutter-sm">
						<div class="col-12 q-mb-xl" v-for="(question, index) in previous_result" :key="index">
							<div class="row q-col-gutter-md">
								<div class="col-12 q-pl-lg linkfix">
									<span v-html="question.title"></span>
								</div>

								<div class="col-12" v-for="answer in question.answers" :key="answer.user_answer_id">
									<q-card
										flat
										class="bg-grey-3"
										:class="
											question.answer === answer.value
												? question.is_correct
													? 'border-positive'
													: 'border-negative'
												: ''
										"
									>
										<q-card-section>
											<q-radio
												disable
												v-model="question.answer"
												:val="answer.value"
												:label="answer.label"
												:color="
													question.answer === answer.value
														? question.is_correct
															? 'positive'
															: 'negative'
														: ''
												"
											/>
										</q-card-section>
									</q-card>
								</div>
							</div>
						</div>
					</div>
				</q-card-section>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'GeneralTest',

	props: ['activity', 'type'],

	data() {
		return {
			columns: [
				{
					align: 'left',
					field: 'date',
					label: 'date',
					name: 'date',
					sortable: false,
				},
				{
					align: 'left',
					field: 'percent',
					label: 'percentage',
					name: 'percent',
					sortable: false,
				},
				{
					align: 'left',
					field: 'score',
					label: 'correct',
					name: 'score',
					sortable: false,
				},
				{
					align: 'left',
					field: 'test_score',
					label: 'points',
					name: 'test_score',
					sortable: false,
				},
				{
					align: 'left',
					field: 'status',
					label: 'status',
					name: 'status',
					sortable: false,
				},
				{
					align: 'center',
					field: 'see_answers',
					label: 'see_answers',
					name: 'actions',
					sortable: false,
				},
			],
			countdown: false,
			current_question: null,
			finished: false,
			pagination: {
				descending: true,
				page: 1,
				rowsPerPage: 3,
				sortBy: 'desc',
			},
			previous_result: [],
			questions: [],
			result: null,
			show_previous_result: false,
			show_previous_results: false,
			started: false,
			time_to_answer: 0,
			user_restarted_blocked: false,
			warning_class: '',
			allowed_to_answer: false,
			start_date: null,
		}
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			block_activities_menu: 'activities/block_activities_menu',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		disableNextQuestion() {
			if (this.questions[this.current_question].answer === '') return true
			else return false
		},

		disableStartTest() {
			if (
				this.activity.maximum_attempts &&
				this.activity.qty_attempted >= this.activity.maximum_attempts
			)
				return true
			if (
				this.activity.user_test_results?.find((e) => e.percent >= 100) ||
				this.activity.user_test_results?.length > 0
			)
				return true
			return false
		},

		progress() {
			if (this.questions.length > 0)
				return (
					this.questions.reduce(
						(counter, { answer }) => (answer !== '' ? counter + 1 : counter),
						0
					) / this.questions.length
				)
			else return 0
		},

		colorResult() {
			if (this.activity.is_approved) return 'positive'
			else if (this.activity.is_blocked) return 'negative'
			else if (!this.activity.is_approved && this.activity.user_test_results.length > 0)
				return 'negative'
			else return 'red'
		},

		textResult() {
			if (this.activity.is_approved) return 'approved'
			else if (this.activity.is_blocked) return 'blocked'
			else if (!this.activity.is_approved && this.activity.user_test_results.length > 0)
				return 'reproved'
			else return 'not_started'
		},

		isTrailCourse() {
			if (this.$route.name === 'trail_course_activity') return true
			else return false
		},

		testSeeResult() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) return client.group_training_test_see_result
			else return false
		},

		isMobile() {
			return this.$q.platform.is.mobile
		},
	},

	methods: {
		loadTest() {
			this.$q.loading.show()

			this.$axios
				.get(
					`/etraining_courses/group_training/${this.$route.params.id}/group_training_test/${this.activity.type_id}/`
				)
				.then((response) => {
					this.start_date = response.data.start_date
					this.questions = response.data.group_training_test_questions.map((q) => {
						return {
							...q,
							answer: '',
							error: false,
							answers: q.group_training_test_question_answers.map((a) => {
								return { label: a.title, value: a.id }
							}),
						}
					})

					let t = response.data.time_to_answer
					this.time_to_answer =
						Number(t.split(':')[0]) * 60 * 60 * 1000 +
						Number(t.split(':')[1]) * 60 * 1000 +
						Number(t.split(':')[2] * 100)

					this.current_question = 0
					this.started = true
					this.countdown = true
					this.$store.dispatch('activities/SET_BLOCK_ACTIVITIES_MENU', [true])
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		saveAnswer() {
			this.$q.loading.show()

			let fd = new FormData()

			fd.append('question_id', this.questions[this.current_question].id)
			fd.append('answer_id', this.questions[this.current_question].answer)

			if (this.questions.length - 1 === this.current_question) {
				fd.append('start_date', this.start_date)
			}

			this.$axios
				.post(
					`/etraining_courses/group_training/${this.$route.params.id}/group_training_test/${this.activity.type_id}/submit_question/`,
					fd
				)
				.then((response) => {
					if (!response.data.id) this.current_question++
					else {
						this.result = response.data
						this.countdown = false
						this.finished = true
						if (response.data.status === 4 || response.data.status === 3)
							this.user_restarted_blocked = true
					}
				})
				.catch((e) => {
					console.log(e)
					this.$store.dispatch('activities/SET_BLOCK_ACTIVITIES_MENU', [false])
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		countdownEnded() {
			this.$q.loading.show()
			this.$store.dispatch('activities/SET_BLOCK_ACTIVITIES_MENU', [false])

			this.$axios
				.get(
					`/etraining_courses/group_training/${this.$route.params.id}/group_training_test/${this.activity.type_id}/set_group_training_test_user_expired/`
				)
				.then((response) => {
					this.result = response.data
					this.countdown = false
					if (response.data.status === 4 || response.data.status === 3)
						this.user_restarted_blocked = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
					this.finished = true
					this.$mitt.emit('forceGetActivities', [])
				})
		},

		finishTest() {
			this.$q.loading.show()
			this.$store.dispatch('activities/SET_BLOCK_ACTIVITIES_MENU', [false])

			let data = {
				start_date: this.start_date,
				answers: this.questions.map((e) => ({ id: e.id, answer_id: e.answer })),
			}

			this.$axios
				.post(
					`/etraining_courses/group_training/${this.$route.params.id}/group_training_test/${this.activity.type_id}/submit/`,
					data
				)
				.then((response) => {
					this.result = response.data
					this.finished = true

					if (response.data.status === 4 || response.data.status === 3)
						this.user_restarted_blocked = true

					this.$mitt.emit('forceGetActivities', [])
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showPreviousResult(result) {
			this.$q.loading.show()

			this.$axios
				.get(
					`/etraining_courses/group_training/${this.id}/group_training_test/${this.activity.type_id}/group_training_test_user_result/${result.id}/`
				)
				.then((response) => {
					this.previous_result = response.data.questions.map((q) => {
						return {
							...q,
							answer: q.user_answer_id,
							answers: q.group_training_test_question_answers.map((a) => {
								return { label: a.title, value: a.id }
							}),
						}
					})
					this.show_previous_result = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		backToResults() {
			this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
				this.activity,
				{ allowed_to_answer: false },
			])

			this.$mitt.emit('forceGetActivities', [])

			if (this.block_activities_menu)
				this.$store.dispatch('activities/SET_BLOCK_ACTIVITIES_MENU', [false])

			this.started = false
			this.finished = false
			this.result = null

			if (this.user_restarted_blocked) {
				this.user_restarted_blocked = false

				if (this.$route.name === 'trail_course_activity')
					this.$router.push({
						name: 'trail_course',
						params: { id_trail: this.$route.params.id_trail, id: this.id },
					})
				else this.$router.push({ name: 'course', params: { id: this.id } })
			}
		},

		statusText(status) {
			if (status === 1) return 'approved'
			else if (status === 2) return 'reproved'
			else if (status === 3) return 'blocked'
			else if (status === 4) return 'restarted'
			else if (status === 5 || status === 50 || status === 60) return 'improved'
		},

		statusColor(status) {
			if (status === 1) return 'text-positive'
			else if (status === 2) return 'text-negative'
			else if (status === 3) return 'text-negative'
			else if (status === 4) return 'text-info'
			else if (status === 5 || status === 50 || status === 60) return 'text-positive'
		},

		getMinimumScorePercentage(minimum_score, questions) {
			return ((minimum_score / questions) * 100).toFixed(2)
		},

		timeToAnswer(time_to_answer) {
			let time = time_to_answer.split(':')
			let time_string = ''

			if (time[0] !== '00')
				time_string += `${parseInt(time[0])} ${this.$t(
					parseInt(time[0]) == 1 ? 'hour' : 'hour_plural',
					{ count: parseInt(time[0]) }
				)} `
			if (time[0] !== '00' && time[1] !== '00') time_string += `${this.$t('and')} `
			if (time[1] !== '00')
				time_string += `${parseInt(time[1])} ${this.$t(
					parseInt(time[1]) == 1 ? 'minute' : 'minute_plural',
					{ count: parseInt(time[1]) }
				)}`

			return time_string
		},

		transformValues(props) {
			Object.entries(props).forEach(([key, value]) => {
				const digits = value < 10 ? `0${value}` : value
				props[key] = `${digits}`
			})

			return props
		},

		handleProgress(data) {
			if (data.totalMilliseconds / 1000 <= 300) this.warning_class = 'text-negative'
		},
	},
}
</script>

<style lang="scss" scoped>
.fit-fix {
	overflow: auto;
}
.test-placeholder {
	width: auto;
	height: 20vh;
}
.padding-item {
	padding: 2px 0px;
}
</style>
